// The product name and help address (SPEC-v3 D1, D2). The server decides
// them (APP_NAME, SUPPORT_EMAIL -> GET /api/meta); useMeta() reads that and
// updates this store, so code outside React (document titles) sees the same
// name. Until /api/meta answers, the build-time defaults below are used
// ("Convenor", support@convenor.eu; a build may set VITE_APP_NAME).
// New UI code: use useMeta() (api/meta.ts), never these constants.
export const APP_NAME: string = (import.meta.env.VITE_APP_NAME as string | undefined) || "Convenor";
export const APP_TAGLINE = `${APP_NAME} for EU projects`;
export const SUPPORT_EMAIL = "support@convenor.eu";

export type Brand = { appName: string; supportEmail: string; tagline: string };

let current: Brand = { appName: APP_NAME, supportEmail: SUPPORT_EMAIL, tagline: APP_TAGLINE };

export function setBrand(next: Brand): void {
  current = next;
}

/** The brand as last read from /api/meta (or the defaults). */
export function brand(): Brand {
  return current;
}

/** "Page · Convenor": the document title of every screen (COVERAGE test convention). */
export function pageTitle(title: string): string {
  return title ? `${title} · ${current.appName}` : current.appName;
}
